import { useTranslation } from 'react-i18next';
import type { QueueAccount } from './QueueAccountsFieldset';
import { QueueAccountIdentity } from './QueueAccountIdentity';
import { QUEUE_ACCOUNT_PLATFORMS } from './queueAccountPlatforms';

export function QueueAccountSummary({ connections }: { connections: QueueAccount[] }) {
  const { t } = useTranslation();
  const groups = QUEUE_ACCOUNT_PLATFORMS.map((platform) => ({
    ...platform,
    accounts: connections.map((connection, index) => ({ connection, order: index + 1 }))
      .filter(({ connection }) => connection.platform === platform.platform),
  })).filter(({ accounts }) => accounts.length > 0);

  return (
    <div className="min-w-0 space-y-4">
      {groups.map((group) => (
        <section key={group.platform} aria-label={group.label} className="min-w-0 space-y-2">
          <h4 className="flex items-center gap-2 text-xs font-medium">
            <span className="flex h-5 w-5 shrink-0 items-center justify-center">{group.icon}</span>
            {group.label}
            <span className="font-normal tabular-nums text-muted-foreground">{group.accounts.length}</span>
            <span aria-hidden="true" className="ml-1 h-px flex-1 bg-border" />
          </h4>
          <ol className="space-y-2">
            {group.accounts.map(({ connection, order }) => (
              <li key={connection.id} value={order} className="flex min-w-0 items-center gap-3 rounded-lg border bg-background/40 p-2.5 text-sm">
                <QueueAccountIdentity connection={connection} platform={group} />
                <span aria-label={t('publishQueues.card.publishingOrder', { position: order })}
                  className="flex h-5 min-w-5 shrink-0 items-center justify-center rounded bg-primary/10 px-1 text-[11px] font-medium tabular-nums text-primary">
                  {order}
                </span>
              </li>
            ))}
          </ol>
        </section>
      ))}
      {groups.length === 0 && <p className="text-sm text-muted-foreground">{t('publishQueues.card.noAccounts')}</p>}
    </div>
  );
}
